import React, { useState, useEffect } from 'react';
import '../Hero.css'; // Import the CSS file for animations

const Hero = () => {
  const images = [
    '/Win1.jpg',
    '/Win5.jpg',
    '/nano1.jpg',
    '/nova3.jpg',
    '/nov.png',
    '/Win6.jpg',
    '/win7.jpg',
    '/Rift.png'



  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="hero-container">
      {/* Logo and Tagline */}
      <div className="content">
  <h1
    className="logo animate-slide-in-right text-transparent bg-clip-text bg-gradient-to-r from-white to-black text-center"
    style={{
      fontSize: '4rem',
      textShadow: '2px 2px 10px rgba(235, 234, 234, 0.9)',
    }}
  >
    AlphaQ
  </h1>

        <p
          className="tagline animate-fade-in-down"
          style={{ fontWeight: 'bold', opacity: 0.9 }}
        >
          Innovate, Transform, Succeed
        </p>
      </div>

      {/* Animated Images */}
      <div className="image-slider">
        {images.map((image, index) => (
          <div
            key={index}
            className={`image-slide ${index === currentImageIndex ? 'active' : ''}`}
            style={{
              backgroundImage: `url(${image})`,
            }}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
